import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useAppSelector } from 'shared/hooks/redux';

interface SelectedProjectState {
  id: number | null;
}

const initialState: SelectedProjectState = { id: null };

const selectedProjectSlice = createSlice({
  name: 'selectedProject',
  initialState,
  reducers: {
    setSelectedProject(_state, action: PayloadAction<number | null>) {
      return { id: action.payload };
    },
    clearSelectedProject() {
      return initialState;
    },
  },
});

export const { setSelectedProject, clearSelectedProject } = selectedProjectSlice.actions;
export const useSelectedProjectId = (): number | null => useAppSelector((state) => state.selectedProject.id);

export default selectedProjectSlice.reducer;
